var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4764 0C23.7365 0 30.4478 6.76864 30.4478 15.0287C30.4478 23.2887 23.7365 30 15.4764 30C7.2164 30 0.505117 23.2887 0.505117 15.0287C0.447758 6.76864 7.15904 0 15.4764 0ZM15.4764 27.7055C22.4745 27.7055 28.1533 22.0268 28.1533 15.0287C28.1533 8.03059 22.4745 2.35182 15.4764 2.35182C8.47835 2.35182 2.79957 8.03059 2.79957 15.0287C2.74221 22.0268 8.42099 27.7055 15.4764 27.7055Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7462 6.94219C19.7787 5.90968 21.4422 7.5158 20.3524 8.54831C18.1726 10.728 15.9929 12.9078 13.8132 15.0875C15.9929 17.2672 18.1726 19.447 20.3524 21.6267C21.3849 22.6592 19.7787 24.3227 18.7462 23.2328C16.2797 20.7663 13.8132 18.2997 11.3466 15.8332C10.8877 15.3743 10.8877 14.6286 11.3466 14.2271C13.8132 11.8179 16.2797 9.35137 18.7462 6.94219Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousBtn);
export default __webpack_public_path__ + "static/media/previousBtn.0a42a797a690f0805f3db8ac8dd256b7.svg";
export { ForwardRef as ReactComponent };